require('./loanPartialAmortizationStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
// @ helpers
const { getLastNChars } = require('utilities/stringHelper');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const LoanPartialAmortizationSimulator = require('../loanPartialAmortizationSimulator/loanPartialAmortizationSimulator');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');

class LoanPartialAmortizationStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.getModalBalance = this.getModalBalance.bind(this);
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loan-partial-amortization-step-one__collective-tag"
                immLoan={immLoan}
            />
        );
    }

    getModalBalance() {
        const { immPartialAmortization, updateEnoughBalance } = this.props;
        const hasEnoughBalance = immPartialAmortization.get('hasEnoughBalance');
        const modalContent = (
            <React.Fragment>
                <p className="loan-partial-amortization-step-one__modal-description">
                    {formatText('loanPartialAmortizationModal-description')}
                </p>
                <p className="loan-partial-amortization-step-one__modal-text">
                    {formatText('loanPartialAmortizationModal-text')}
                </p>
            </React.Fragment>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={hasEnoughBalance}
                onCloseCallback={updateEnoughBalance}
                onPrimaryButtonClick={updateEnoughBalance}
                onSecondaryButtonClick={updateEnoughBalance}
                primaryButtonText="loanPartialAmortizationModal-modifyButton"
                secondaryButtonText="loanPartialAmortizationModal-backButton"
                title="loanPartialAmortizationModal-title"
            />
        );
    }

    render() {
        const { immPartialAmortization, immLoan, productName,newLoanPartialFF } = this.props;

        const amortizationData = immPartialAmortization.get('partialAmortizationData');
        const currencyBalanceParams = {
            currency: Math.abs(immPartialAmortization.get('balance'))
        };
        const currencyInitialCapitalParams = {
            currency: amortizationData.getIn(['initLimitAmount', 'amount'])
        };
        const currencyPendingCapitalParams = {
            currency: amortizationData.getIn(['currentLimitAmount', 'amount'])
        };
        const currencyQuotaParams = {
            currency: immPartialAmortization.get('receiptTotal')
        };
        const formattedAssociatedAccount = `${immPartialAmortization.get('description')} ${getLastNChars(immPartialAmortization.get('accountNumber'))}`;
        const badge = this.buildBadge();
        const modalBalance = this.getModalBalance();

        return (
            <div className="loan-partial-amortization-step-one">

                {modalBalance}

                <h3 className="loan-partial-amortization-step-one__title">
                    {`${formatText('loanPartialAmortization-subtitle')} ${productName}`}
                </h3>
                {badge}
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-asociatedAccount')}
                        bodyText={formattedAssociatedAccount}
                    />
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-balance')}
                        bodyText={MortgageRequestCurrencyHelp(currencyBalanceParams)}>
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-initialCapital')}
                        bodyText={MortgageRequestCurrencyHelp(currencyInitialCapitalParams)}
                    />
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-dueDate')}
                        bodyText={amortizationData.get('dueDate')}
                    />
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-pendingCapital')}
                        bodyText={MortgageRequestCurrencyHelp(currencyPendingCapitalParams)}
                    />
                    <OKInformativeListItem
                        title={formatText('loanPartialAmortization-currentQuota')}
                        bodyText={MortgageRequestCurrencyHelp(currencyQuotaParams)}
                    />
                </OKInformativeList>

                <span className="loan-partial-amortization-step-one__simulator-title">
                    {formatText('loanPartialAmortization-simulatorTitle')}
                </span>

                <LoanPartialAmortizationSimulator immLoan={immLoan} newLoanPartialFF={newLoanPartialFF}/>
            </div>
        );
    }
}

LoanPartialAmortizationStep1.propTypes = {
    immPartialAmortization: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    productName: PropTypes.string.isRequired,
    updateEnoughBalance: PropTypes.func.isRequired
};

module.exports = LoanPartialAmortizationStep1;
